import './index.css';
import { jsx } from 'react/jsx-runtime';

const enrichWithSkeleton = (Component, IncompleteSkeleton) => {
    const ComponentWithSkeleton = Component;
    const Skeleton = (props) => (jsx(IncompleteSkeleton, { ...props, Component: Component }));
    ComponentWithSkeleton.Skeleton = Skeleton;
    return ComponentWithSkeleton;
};

export { enrichWithSkeleton };
//# sourceMappingURL=enrichWithSkeleton.js.map
